import Cookies from 'js-cookie'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import AppRoutes from '@/routes/AppRoutes'

import { loadingOverlaySelector } from '@/stores/ui/loadingOverlaySlice'
import storage from '@/utils/storage'
import { LoadingOverlay, LoadingSection } from '@/components/Elements'
import { authSelector, initAuth, loadMe } from './stores/auth/authSlice'
const App = () => {
  const dispatch = useDispatch()

  const { appLoaded, isAuthenticated } = useSelector(authSelector)
  const { show: showLoadingOverlay, text: loadingText } = useSelector(loadingOverlaySelector)

  useEffect(() => {
    //Handle Redirect from Oauth callback's redirection (Cookie has been by server)
    const cookieJwt = Cookies.get('x-auth-cookie')

    if (cookieJwt) {
      console.log('Received token from server: ', cookieJwt)
      // Cookies.remove('x-auth-cookie')
      storage.setToken(cookieJwt)
      dispatch(loadMe())
    }
  }, [dispatch])

  useEffect(() => {
    //Do a transformation

    const hasUpdated = localStorage.getItem('update_table_state_script_ran')
    if (hasUpdated) {
      return
    }
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)

      if (!key.includes('table_state')) continue

      try {
        const value = localStorage.getItem(key)

        const tableState = JSON.parse(value)

        // localStorage.setItem(key, JSON.stringify({ value: tableInitialState }))

        if (tableState?.value) {
          localStorage.setItem(key, JSON.stringify(tableState.value))
        }
      } catch (err) {
        // localStorage.removeItem(key)
      }
    }

    localStorage.setItem('update_table_state_script_ran', 'true')
  }, [])

  useEffect(() => {
    //If Success, it means there is a valid token
    if (isAuthenticated || storage.getToken()) {
      dispatch(loadMe())
    } else {
      dispatch(initAuth())
    }
  }, [dispatch, isAuthenticated])

  if (!appLoaded) {
    return <LoadingSection />
  }

  return (
    <BrowserRouter>
      <LoadingOverlay isActive={showLoadingOverlay} text={loadingText} />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
